/**
 * Session Error Codes
 * Defines all possible error scenarios for session management
 */
export enum SessionErrorCode {
  NO_SESSION = 'no_session',
  INVALID_SESSION = 'invalid_session',
  SESSION_EXPIRED = 'session_expired',
  VERIFICATION_FAILED = 'verification_failed',
  TOO_MANY_REQUESTS = 'too_many_requests',
  NETWORK_ERROR = 'network_error',
  UNKNOWN_ERROR = 'unknown_error'
}

/**
 * Session Error Model
 * Contains error information and recovery options
 */
export interface SessionError {
  code: SessionErrorCode;
  message: string;
  canRetry: boolean;
  userMessage?: string;
  technicalDetails?: any;
}

/**
 * Session Status
 * Represents the current state of the session
 */
export type SessionStatus = 'active' | 'expired' | 'refreshing' | 'error' | 'initializing';

/**
 * Session Event
 * Emitted when session state changes
 */
export interface SessionEvent {
  status: SessionStatus;
  error?: SessionError;
  timestamp: number;
}
